import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=771c7580&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771c7580",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('771c7580')) {
      api.createRecord('771c7580', component.options)
    } else {
      api.reload('771c7580', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=771c7580&scoped=true&", function () {
      api.rerender('771c7580', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2CLctfy2rxxAH/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports